<template>
    <div class="main-tech">
        <span>Technical Details</span>
        <div class="tech-con">
            <div class="dot-main">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Vulnerability Identified</span>: CVE-2024-XXXXX (Pending Vendor Assignment)
                </div>
            </div>
            <div class="dot-main">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Exploit Type</span>: Remote Code Execution (RCE) via deserialization attack
                </div>
            </div>
            <div class="dot-main">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Impact Scope</span>:
                </div>
            </div>
            <div class="dot-sub">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Affected user accounts</span>: ~2.1 million
                </div>
            </div>
            <div class="dot-sub">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Compromised authentication records</span>: 350,000+
                </div>
            </div>
            <div class="dot-sub">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <circle cx="4" cy="4" r="3" fill="#09090B" />
                </svg>
                <div class="ml-2 w-full sm:w-auto">
                    <span>Affected database clusters</span>: 3 (user profiles, authentication logs, API credentials)
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.main-tech {
    @apply flex flex-col items-start gap-2;

    span {
        @apply text-zinc-700 font-inter text-base font-semibold leading-6;
    }
}
.tech-con {
    @apply text-zinc-950 font-inter text-sm font-normal leading-6;

    span {
        @apply text-zinc-950 font-inter text-sm font-semibold leading-6;
    }

    .dot-main {
        @apply flex flex-row items-center ml-2;
    }

    .dot-sub {
        @apply flex flex-row items-center ml-8;
    }
}
</style>
